export function classificateArterialPressure(systolicArterialPressure: number) {
	if (!systolicArterialPressure || systolicArterialPressure < 100) return "";
	if (systolicArterialPressure < 120) return "Limite superior de 100";
	if (systolicArterialPressure < 140) return "Limite superior de 120";
	if (systolicArterialPressure < 160) return "Limite superior de 140";
	if (systolicArterialPressure < 180) return "Limite superior de 160";
	if (systolicArterialPressure < 200) return "Limite superior de 180";
	return "Limite superior de 200 ou mais";
}
